import { useQuery } from "@tanstack/react-query";
import { baseAxios } from "../apis";

export function useActivityChartQuery(botId, timeframe = "1D") {
  return useQuery({
    queryKey: ["activity", botId, timeframe],
    queryFn: async () => {
      const { data } = await baseAxios.get(
        `/api/bot_detail/${botId}/activity_chart`,
        { params: { timeframe } }
      );

      const candles = (data.candles || []).map((c) => ({
        time: Math.floor(new Date(c.time).getTime() / 1000),
        open: Number(c.open_price),
        high: Number(c.high_price),
        low: Number(c.low_price),
        close: Number(c.close_price),
      }));

      const fixedMarkers = (data.markers || []).map((m) => ({
        ...m,
        unixTime: m.timestamp
          ? Math.floor(new Date(m.timestamp).getTime() / 1000)
          : null,
      }));

      const grid_lines = (data.grid_lines || []).map((g) => ({
        price: Number(g.price),
        label: g.label || "",
        type: g.type || "", // keep the type (buy/sell)
      }));

      return { candles, markers: fixedMarkers, grid_lines };
    },
    enabled: !!botId,
    refetchOnWindowFocus: false,
  });
}
